import * as React from "react";

import { useAccountSettings } from "@/utils";
import { SubscribedPlayerSearchResponse, WebComponents } from "@/interfaces";
import {
  PlayerSubscriptionForm,
  PlayerSettingsForm,
  PlayerSegmentationForm,
  PlayerCampaigns,
} from "@/containers/Coach/EditPlayer/components";

interface Props {
  player: SubscribedPlayerSearchResponse;
  reloadPlayer: () => void;
  clearCaches: () => void;
}

export function PlayerInfoTab({ player, clearCaches, reloadPlayer }: Props) {
  const { hasWritePermission } = useAccountSettings();
  const withWritePermission = hasWritePermission(WebComponents.PLAYERS);
  const isActivePlayer = player.pricePlanSubscription!.status !== "CANCELED";

  return (
    <div className="flex flex-col gap-6 w-full max-w-5xl">
      <div className="grid grid-cols-2 gap-6">
        <PlayerSubscriptionForm
          player={player}
          withWritePermission={withWritePermission}
          clearCaches={clearCaches}
          reloadPlayer={reloadPlayer}
        />

        <PlayerSettingsForm
          playerId={player.playerAccount.playerId}
          withWritePermission={isActivePlayer && withWritePermission}
        />

        <PlayerSegmentationForm
          player={player}
          withWritePermission={isActivePlayer && withWritePermission}
          clearCaches={clearCaches}
          reloadPlayer={reloadPlayer}
        />

        <PlayerCampaigns playerId={player.playerAccount.playerId!} />
      </div>
    </div>
  );
}
